'use client';

var calculatePiece = function (params) {
    var perimeter = params.perimeter, percent = params.percent, index = params.index, piecePerimeter = params.piecePerimeter, piecePercent = params.piecePercent;
    // Calculate "from percent" "to percent" by index
    var fromPercent = index * piecePercent;
    var toPercent = (index + 1) * piecePercent;
    if (percent >= toPercent) {
        // return full
        return perimeter - piecePerimeter;
    }
    if (fromPercent < percent && percent <= toPercent) {
        // return calculate
        var segmentPercent = percent - fromPercent;
        return perimeter - (segmentPercent * piecePerimeter) / piecePercent;
    }
    return perimeter;
};

export { calculatePiece };
//# sourceMappingURL=helpers.js.map
